// NSDCRegistration.jsx
import React from "react";

export default function NSDCRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            NSDC Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            NSDC Training Provider Registration
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists training providers in obtaining NSDC
            Registration to participate in Skill India programs and deliver
            NSQF-aligned vocational training across approved job roles.
          </p>
          <p className="text-gray-700">
            The registration process through Skill India Digital Hub (SIDH)
            provides Training Provider (TP) ID, access to Sector Skill Councils,
            and eligibility for government schemes and funding opportunities.
          </p>
        </div>

        {/* Right: Image (FIXED - Guaranteed working NSDC training image) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/267885/pexels-photo-267885.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Training provider obtaining NSDC Registration"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* PROFESSIONAL SUPPORT & DOCUMENTS SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Professional compliance support */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Professional Compliance Support by Hawkins &amp; Brooks
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks provides complete assistance for NSDC Training
              Provider registration on Skill India Digital Hub (SIDH) platform.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  Skill India Portal registration as Training Provider (TP) with
                  SPOC details and document upload management.
                </li>
                <li>
                  Desktop assessment preparation including infrastructure,
                  financials, trainer qualifications, and compliance verification.
                </li>
                <li>
                  Training Centre (TC) creation and Centre Accreditation &
                  Affiliation (CAA) application support with Sector Skill Councils.
                </li>
                <li>
                  Ongoing compliance for job role approvals, batch creation,
                  assessments, and Skill India certification processes.
                </li>
              </ul>
            </div>
          </div>

          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for NSDC Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps compile organizational and compliance
              documents required for Training Provider registration approval.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Organizational details including registration certificate, PAN card, and GST registration.</li>
                <li>
                  Training infrastructure information with centre layout,
                  equipment specifications, and capacity details.
                </li>
                <li>
                  Trainer qualification documents (ToT certificates, educational
                  qualifications, and industry experience proofs).
                </li>
                <li>
                  Financial statements and compliance declarations for Skill India
                  ecosystem participation.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm specializes in skill development compliance with proven
              expertise in NSDC Training Provider registration processes.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Skill Development Compliance Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete understanding of NSDC affiliation, Skill India Portal,
                  Sector Skill Council requirements, and NSQF alignment standards.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Registration Handling
                </h3>
                <p className="text-gray-700 text-sm">
                  Professional portal management, document structuring, and
                  assessment preparation for seamless Training Provider approval.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Advisory Support
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end guidance from TP registration through TC
                  accreditation, job role approvals, and Skill India scheme participation.
                </p>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="flex flex-col justify-center">
            <div className="bg-gray-50 border border-yellow-100 rounded-2xl p-6 shadow-sm">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                Join Skill India Training Network
              </h3>
              <p className="text-gray-700 mb-5">
                Connect with Hawkins &amp; Brooks to complete your NSDC Training
                Provider registration and deliver nationally recognized skill
                programs under the Skill India Digital ecosystem.
              </p>
              <div className="flex flex-wrap gap-3">
                <a
                  href="/contact"
                  className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
                >
                  Get Consultation
                </a>
                <a
                  href="tel:+919217468906"
                  className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
                >
                  Call Hawkins &amp; Brooks
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
